<template>
  <div :style="getWidth()">
    <div v-if="title" class="input-title">{{title}}</div>
    <div v-if="type == 'text'" class="input-containear">
      <input type="text" v-model="inputValue" class="input-value" :placeholder="placeholder ? placeholder : 'Digite o nome'">
      <span v-on:click="returnValue()" class="material-icons input-icon">search</span>
    </div>
    <div v-if="type == 'select'" class="input-containear" >
      <select v-model="selectValue" class="input-select-value" :disabled="getDisabledList()" style="cursor: pointer;">
        <option disabled :value="''">{{placeholder}}</option>
        <option v-for="(x, idx) in list" :value="x.value" :key="idx">{{x.text}}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StandardInputAuto',
  props: ['title', 'width', 'type', 'list', 'value', 'action', 'placeholder'],
  data () {
    return {
      inputValue: '',
      selectValue: ''
    }
  },
  methods: {
    getDisabledList(){
      if (this.list.length < 1) return true
      return false
    },
    getWidth(){return 'width: ' + this.width},
    returnValue(){ this.action(this.inputValue) }
  },
  watch: {
    selectValue(newValue){ this.action(newValue) },
    inputValue(newValue){ this.action(newValue) }
  }
}
</script>

<style scoped>
.input-title{
  font-weight: 400;
  font-size: 1.5em;
  letter-spacing: 0.15px;
  color: #898989;
}
.input-containear{
  border: 1px solid #E5E5E5;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 1.5vh 0.7vw;
  height: 6vh;
  display: flex;
}
.input-value{
  border: none;
  flex: 1;
  font-weight: 400;
  font-size: 1.2em;
  letter-spacing: 0.15px;
  color: #B3B3B3;
}
.input-value:focus{
  border: none;
  outline: none;
}
.input-icon{
  color: #B3B3B3;
  cursor: pointer;
  font-size: 1.8em;
}
.input-select-value{
  border: none;
  font-weight: 400;
  font-size: 1.3em;
  letter-spacing: 0.15px;
  color: #B3B3B3;
  flex: 1;
}
.input-select-value:focus{
  border: none;
  outline: none;
}
</style>